var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imgUrl),expression:"imgUrl"}],staticClass:"piston-head-logo",attrs:{"alt":"Piston Heads Logo","height":"25"}})
}
var staticRenderFns = []

export { render, staticRenderFns }